import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		hasLogin: false, //用户是否登录
		user: {}, //用户数据
		login:{} , //个人数据
	},
	mutations: {
		// 登录
		login(state, user) {
			//登录状态为已登录
			state.hasLogin = true
			state.user = user
			//储存用户数据到本地
			localStorage.setItem('user', JSON.stringify(state.user));
			// console.log('登陆成功')
			console.log(state.hasLogin, state.userInfo)
		},
		// 退出登录
		logout(state, user) {
			//登录状态为未登录
			state.hasLogin = false
			state.userInfo = {}
			//删除本地储存
			localStorage.removeItem('user')
			localStorage.removeItem('lname')
			localStorage.removeItem('userInfo')
			sessionStorage.removeItem('vuex')
			sessionStorage.removeItem('token')
			// console.log('退出登录')
			// console.log(state.hasLogin, state.userInfo)
		},
		// 存储主页名字
		lname(state, user){
			if(state.hasLogin){
				state.login = user
			}
			// console.log(state.login)
		},
	},
	actions: {},
	plugins: [createPersistedState({
		storage: window.sessionStorage,
		reducer(val) {
			return {
				// 只储存state中的token
				assessmentData: val.hasLogin
			}
		}
	})]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js